// Картата „Продукти" на листа „Прехвърляне": заглавие с броя и решетката/
// картите с ЕДИН keydown handler за стрелките (`onGridKey`). Картата расте до
// края на екрана и скролва вътре — заглавният ред на решетката остава лепнат.
import { useTranslation } from "react-i18next";
import { TransferWorksheetTable, type TransferTableProps } from "./TransferWorksheetTable";

type Props = {
  onGridKey: (event: React.KeyboardEvent) => void;
  table: TransferTableProps;
};

export const TransferProductsCard = ({ onGridKey, table }: Props) => {
  const { t } = useTranslation();
  const count = table.rows.length;
  return (
    <div className="flex min-h-[360px] flex-1 flex-col overflow-hidden rounded-xl border border-shade-2 bg-panel">
      <div className="flex flex-wrap items-center gap-2.5 px-[18px] py-[13px]">
        <span className="text-[15px] font-semibold text-ink">{t("inventoryPage.productsTitle")}</span>
        <span className="text-[12.5px] text-muted">{t("inventoryPage.homeDraftLines", { count })}</span>
      </div>
      {/* Един handler за цялата решетка: ↑↓←→ / Enter / Esc */}
      <div
        className={`min-h-0 flex-1 overflow-auto border-t border-shade-2 text-[13px] ${
          count ? "bg-surface" : "bg-panel"
        }`}
        onKeyDown={onGridKey}
      >
        <TransferWorksheetTable {...table} />
      </div>
    </div>
  );
};

export default TransferProductsCard;
